module.exports = __webpack_public_path__ + "static/assets/5d247c43656459187c2a0525241d8ed1.svg";